import { Box, InputAdornment, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, useEffect } from "react";

type SearchProps = {
  searchTerm: string;
  setDebouncedSearchTerm: (val: string) => void;
  setSearchTerm?: (val: string) => void;
  placeholder: string;
  onCross?: () => void;
};

const SearchBar = ({
  searchTerm,
  setDebouncedSearchTerm,
  setSearchTerm,
  placeholder,
  onCross,
}: SearchProps) => {
  const [localValue, setLocalValue] = useState(searchTerm || "");
  useEffect(() => {
    setLocalValue(searchTerm || "");
  }, [searchTerm]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(localValue);
    }, 500); // 500ms debounce

    return () => clearTimeout(timer);
  }, [localValue, setDebouncedSearchTerm]);

  const handleClear = () => {
    setLocalValue("");
    setSearchTerm?.("");
    setDebouncedSearchTerm("");
    onCross && onCross();
  };

  return (
    <Box className="form search_bar">
      <TextField
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        hiddenLabel
        placeholder={placeholder}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className="search_icon">
              <img src="/static/images/searchbar_icon.svg" alt="Icon" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" className="cross_btn">
              {localValue?.length > 0 && (
                <ClearIcon
                  style={{ background: "white", color: "red", cursor: "pointer" }}
                  onClick={handleClear}
                />
              )}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchBar;
